import * as z from "zod";
import { normalizeName } from "./normalizeName";

export const userEmailSchema = z
  .string()
  .trim()
  .email()
  .transform((s) => s.toLowerCase());

export const scimUserNameSchema = z
  .object({
    givenName: z.string().optional().default(""),
    familyName: z.string().optional().default(""),
  })
  .transform(({ givenName, familyName }) => {
    const raw = `${givenName} ${familyName}`.trim();
    return normalizeName(raw);
  });
